/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MxReward } from './MxReward';
import {
    MxRewardFromJSON,
    MxRewardFromJSONTyped,
    MxRewardToJSON,
    MxRewardToJSONTyped,
} from './MxReward';

/**
 * 
 * @export
 * @interface MxRewards
 */
export interface MxRewards {
    /**
     * Balance in the issuer's OWN rewards currency only (Chase Ultimate Rewards, Membership Rewards, ...). Co-branded cards at the same issuer earn a partner's currency and are excluded, because adding United miles to Ultimate Rewards produces a number that cannot be spent as either.
     * NOT the sum of `items`. `items` carries every card at the issuer; the cards contributing here are `items` minus `co_branded_cards` and `cash_back_cards`, matched on `id`. Those two arrays are disjoint from each other, so that set-difference identifies the contributing cards exactly.
     * Do NOT then add those cards up. Amex pre-aggregates: every Membership Rewards card reports the SAME balance, so this field is one card's balance, not their sum — three cards showing 100,000 give 100,000 here, and summing yields 300,000. Detect it by institution_code == "amex". Use this field as given; the set-difference identifies which cards it covers, and is not a formula for recomputing it.
     * @type {number}
     * @memberof MxRewards
     */
    totalRewardPoints?: number;
    /**
     * Cash back held at this issuer, in dollars, summed from rewards MX reports with a DOLLARS unit type. It is already money, so it is never valued at a points rate and is never folded into cash_value — show it as its own figure alongside the points.
     * Null means the user holds no cash-back cards at this issuer. 0.0 means they hold some and the balance is zero — a distinction a client needs to tell "not applicable" from "nothing on it".
     * @type {number}
     * @memberof MxRewards
     */
    cashBackDollars?: number;
    /**
     * Estimated worth of total_reward_points at the programme's redemption rate, and nothing else. Cash back is already money and is reported on its own in cash_back_dollars; the two are deliberately NOT added, because their sum is neither the points' worth nor the account's. Display them as separate figures.
     * Null when the rate is missing or zero — which is not the same as the LoyaltyRedemption row being absent, since a row can carry a null rate. Null means the points cannot be valued, NOT that there are none: total_reward_points can be large while this is null.
     * @type {number}
     * @memberof MxRewards
     */
    cashValue?: number;
    /**
     * EVERY card at this issuer, unchanged. Clients render the wallet from this array and fall back to the loyalty account's embedded card list only when this one is empty — so narrowing it would blank the card list for anyone holding only co-brand cards, an Amex/Delta-only holder say, whose loyalty account is an institution placeholder carrying no cards of its own.
     * co_branded_cards and cash_back_cards name SUBSETS of this array rather than removing anything from it, and hold the SAME object instances, not copies — so a card legitimately appears twice in one payload. De-duplicate on `id` across the three when you need a flat list.
     * @type {Array<MxReward>}
     * @memberof MxRewards
     */
    items?: Array<MxReward>;
    /**
     * Subset of items earning cash back rather than points, identified by a DOLLARS unit type. Their value is cash_back_dollars and must never be added to total_reward_points: 1,060 users hold a points card and a cash-back card at one issuer.
     * Each card's cash_value is its dollar balance at face value. It is NOT run through the points formula, which used to truncate the cents and multiply by a cents-per-point rate — int(25.50) = 25, then 25 at 1.5c reported 0.375 for $25.50.
     * @type {Array<MxReward>}
     * @memberof MxRewards
     */
    cashBackCards?: Array<MxReward>;
    /**
     * Subset of items earning a partner's currency (United, Southwest, Marriott, IHG, ...) rather than the issuer's own. Excluded from total_reward_points because adding United miles to Ultimate Rewards yields a number spendable as neither. For 97% of these the same balance also appears under its own loyalty account; the other 3% appear only here, which is why they stay in items.
     * Each card here is valued at its PARTNER programme's rate; the issuer's rate is never substituted, since pricing United miles at Ultimate Rewards' cents-per-point is what this replaces. When that partner programme has no rate the card's cash_value is 0.0, not absent — Frontier Miles is live in this state today — so treat 0.0 here as "unknown", never as "worthless", and prefer the balance.
     * Show these cards by BALANCE. Their dollars belong to a currency the issuer does not mint, so they must never be added to cash_value or to each other's.
     * @type {Array<MxReward>}
     * @memberof MxRewards
     */
    coBrandedCards?: Array<MxReward>;
}

/**
 * Check if a given object implements the MxRewards interface.
 */
export function instanceOfMxRewards(value: object): value is MxRewards {
    return true;
}

export function MxRewardsFromJSON(json: any): MxRewards {
    return MxRewardsFromJSONTyped(json, false);
}

export function MxRewardsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MxRewards {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRewardPoints': json['total_reward_points'] == null ? undefined : json['total_reward_points'],
        'cashBackDollars': json['cash_back_dollars'] == null ? undefined : json['cash_back_dollars'],
        'cashValue': json['cash_value'] == null ? undefined : json['cash_value'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(MxRewardFromJSON)),
        'cashBackCards': json['cash_back_cards'] == null ? undefined : ((json['cash_back_cards'] as Array<any>).map(MxRewardFromJSON)),
        'coBrandedCards': json['co_branded_cards'] == null ? undefined : ((json['co_branded_cards'] as Array<any>).map(MxRewardFromJSON)),
    };
}

export function MxRewardsToJSON(json: any): MxRewards {
    return MxRewardsToJSONTyped(json, false);
}

export function MxRewardsToJSONTyped(value?: MxRewards | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_reward_points': value['totalRewardPoints'],
        'cash_back_dollars': value['cashBackDollars'],
        'cash_value': value['cashValue'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(MxRewardToJSON)),
        'cash_back_cards': value['cashBackCards'] == null ? undefined : ((value['cashBackCards'] as Array<any>).map(MxRewardToJSON)),
        'co_branded_cards': value['coBrandedCards'] == null ? undefined : ((value['coBrandedCards'] as Array<any>).map(MxRewardToJSON)),
    };
}

